import { useState, useEffect, useRef, RefObject, useCallback } from 'react';

export default function useClickOutside(
  initialIsVisible: boolean,
  includeNodes?: RefObject<HTMLElement>[], // 컴포넌트에 포함시키는 노드들
  callback?: (event?: Event) => void
) {
  const [isComponentClicked, setIsComponentClicked] = useState(initialIsVisible);
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: Event) => {
      const eventTarget = event.target as Node;
      let insideRef = false;

      if (ref?.current === eventTarget || ref?.current?.contains(eventTarget)) {
        insideRef = true;
      }

      const targetNodes = includeNodes || [];
      const insideTargetNodes = targetNodes.some((node) => {
        return node?.current === eventTarget || node?.current?.contains(eventTarget);
      });

      if (!insideRef && !insideTargetNodes) {
        if (event.type === 'click') {
          event.stopPropagation();
        }

        setIsComponentClicked(false);
        callback && callback(event);
      }
    },
    [callback, includeNodes]
  );

  useEffect(() => {
    if (initialIsVisible) {
      document.addEventListener('click', handleClickOutside, true);
    } else {
      document.removeEventListener('click', handleClickOutside, true);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [initialIsVisible, handleClickOutside]);

  return { ref, isComponentClicked, setIsComponentClicked };
}
